module.exports = __webpack_public_path__ + "static/media/js.db7933e6.png";